export const experienceSelector = (state, consultantId, experienceId) => {
  try {
    return state.consultants[consultantId].experience.get(experienceId)
  } catch (e) {
    return undefined
  }
}



// WEBPACK FOOTER //
// ./src/selectors/experience.js